(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  /* ---- Sort dropdown ---------------------------------------------------- */
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ---- Filter drawer open/close ----------------------------------------- */
  var drawer   = document.getElementById('CollectionFilterDrawer');
  var openBtns = document.querySelectorAll('.js-col-filter-open');
  var closeBtns = document.querySelectorAll('.js-col-filter-close');

  function openFilterDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    openBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
  }
  function closeFilterDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    openBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', openFilterDrawer); });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeFilterDrawer); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFilterDrawer();
  });

  /* ---- Filter group accordion ------------------------------------------- */
  document.querySelectorAll('.js-col-filter-group-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
    });
  });

  /* ---- Filter checkbox → URL navigate ----------------------------------- */
  document.querySelectorAll('.js-col-filter-checkbox').forEach(function (cb) {
    cb.addEventListener('change', function () {
      window.location.href = cb.checked ? cb.dataset.urlAdd : cb.dataset.urlRemove;
    });
  });

  /* ---- Price range Apply ------------------------------------------------- */
  document.querySelectorAll('.js-col-price-apply').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.col-filter-group__content');
      if (!group) return;
      var inputs = group.querySelectorAll('input[type="number"]');
      var minInput = inputs[0];
      var maxInput = inputs[1];
      var url = new URL(window.location.href);
      if (minInput && minInput.value) {
        url.searchParams.set(minInput.name, parseFloat(minInput.value) * 100);
      } else if (minInput) {
        url.searchParams.delete(minInput.name);
      }
      if (maxInput && maxInput.value) {
        url.searchParams.set(maxInput.name, parseFloat(maxInput.value) * 100);
      } else if (maxInput) {
        url.searchParams.delete(maxInput.name);
      }
      window.location.href = url.toString();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function () {
  /* ---- Sort dropdown ---------------------------------------------------- */
  var sortSelect = document.querySelector('.js-search-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ---- Filter drawer open/close ----------------------------------------- */
  var drawer    = document.getElementById('SearchFilterDrawer');
  var openBtns  = document.querySelectorAll('.js-filter-open');
  var closeBtns = document.querySelectorAll('.js-filter-close');

  function openFilterDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var openBtn = document.querySelector('.js-filter-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }
  function closeFilterDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var openBtn = document.querySelector('.js-filter-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', openFilterDrawer);
  });
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeFilterDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFilterDrawer();
  });

  /* ---- Filter group accordion ------------------------------------------- */
  document.querySelectorAll('.js-filter-group-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
